module.exports = __webpack_public_path__ + "img/apix_white.bf0c432d.png";